import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Controller from '../Controller/Controller';
import CreateTodo from '../Create-Todo-Form/CreateTodo';
import Listview from '../Listview/Listview';
import TableView from '../TableView/TableView';
import { v4 as uuidv4, v4 } from 'uuid';

export default class Index extends Component {
    state = {
        todos: [
            {
                id: 323232,
                text: 'Buy Milk',
                time: new Date(),
                isComplete: false,
                isSelect: false
            },
            {
                id: 323232332,
                text: 'Buy Milk',
                time: new Date(),
                isComplete: false,
                isSelect: false
            }
        ],
        searchTerm: '',
        isOpen: false,
        view: 'list',
        filter: 'all'
    };

    toggleComplete = id => {
        let todos = [...this.state.todos];
        let todo = todos.find(li => li.id === id);
        todo.isComplete = !todo.isComplete;
        this.setState({ todos });
    };

    toggleSelect = id => {
        let todos = [...this.state.todos];
        let todo = todos.find(li => li.id === id);
        todo.isSelect = !todo.isSelect;
        this.setState({ todos });
    };

    handleSearch = (value) => {
        this.setState({ searchTerm: value });
    };

    performSearch = () => {
        return this.state.todos.filter(todo => todo.text.toLocaleLowerCase().includes(this.state.searchTerm.toLocaleLowerCase()));
    };

    toggleForm = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    handleView = (event) => {
        this.setState({ view: event.target.value });
    };

    deleteCompleted = () => {
        const todos = this.state.todos.filter(todo => !todo.isComplete);
        this.setState({ todos });
    };

    deleteSelected = () => {
        const todos = this.state.todos.filter(todo => !todo.isSelect);
        this.setState({ todos });
    };

    reset = () => {
        this.setState({
            isOpen: false,
            view: 'list',
            searchTerm: '',
            filter: 'all'
        });
    };

    createTodo = todo => {
        todo.id = v4();
        todo.time = new Date();
        todo.isComplete = false;
        todo.isSelect = false;

        let todos = [todo, ...this.state.todos];

        this.setState({ todos: todos });
        this.toggleForm();
    };

    handleFilter = filter => {
        this.setState({ filter });
    };

    performFilter = (todos) => {
        const { filter } = this.state;
        if (filter === 'completed') {
            return todos.filter(todo => todo.isComplete);
        } else if (filter === 'running') {
            return todos.filter(todo => !todo.isComplete);
        } else {
            return todos;
        }
    };

    getView = () => {
        let todos = this.performSearch();
        todos = this.performFilter(todos);
        return this.state.view === 'list' ? (
            <Listview todos={todos} toggleComplete={this.toggleComplete} toggleSelect={this.toggleSelect} />
        ) : (
                <TableView todos={todos} toggleComplete={this.toggleComplete} toggleSelect={this.toggleSelect} />
            );
    };

    render() {
        return (
            <div>
                <h2 className="font-weight-normal text-center">Stack Todos</h2>
                <Controller
                    term={this.state.searchTerm}
                    toggleForm={this.toggleForm}
                    handleFilter={this.handleFilter}
                    handleSearch={this.handleSearch}
                    view={this.state.view}
                    handleView={this.handleView}
                    deleteCompleted={this.deleteCompleted}
                    deleteSelected={this.deleteSelected}
                    reset={this.reset}
                    filter={this.state.filter}
                />
                <div>
                    {this.getView()}
                </div>
                <Modal isOpen={this.state.isOpen} toggle={this.toggleForm} >
                    <ModalHeader toggle={this.toggleForm}>Add your new Task</ModalHeader>
                    <ModalBody>
                        <CreateTodo createTodo={this.createTodo} />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
